// ********************************************************
// Batch registration
// Handles stuff like view and submit weights from Batch registration.
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.LoadItems',
    inputData: {
      Facility: params
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadrecentRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.LoadRecentRegistrations',
    inputData: {
      Facility: params
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.LoadItem',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadBatchOrder (id) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.LoadOrder',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadAllBatchOrders (id) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.GetAll',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadActiveRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.ActiveBatchRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function getCurrentWeightIds (params) {
  const res = await Backend.callApi({
    apiName: 'ScaleWeight.GetCurrentWeightIds',
    inputData: {
      Id: params
    }
  })
  return res
}

export async function getWeight (params) {
  // console.log('Ps', params)
  const res = await Backend.callApi({
    apiName: 'ScaleWeight.GetWeight',
    inputData: {
      ScaleId: params.VT25Id
    }
  })
  return res
}

export async function saveRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.SaveItem',
    inputData: {
      BatchRegistrationItem: params
    }
  })
  return res
}

export async function PrintRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.Print',
    inputData: {
      BatchRegistrationItem: params
    }
  })
  return res
}

export async function RePrintRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.RePrint',
    inputData: {
      BatchRegistration: params
    }
  })
  return res
}

export async function FinishRegistration (AgreementId) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.Finish',
    inputData: {
      AgreementId: AgreementId
    }
  })
  return res
}

export async function UpdateRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.Update',
    inputData: {
      BatchRegistration: params
    }
  })
  return res
}

export async function DelteRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'BatchRegistration.Delete',
    inputData: {
      BatchRegistration: params
    }
  })
  return res
}
